module.exports = __webpack_public_path__ + "static/consult2-ed495d9b27951af3a075015890e4fd2a.png";